@if (alertErro === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/error.png" alt="Representa erro" width="82px">
      <p class="titulo-alert titulo-alert-erro mt-4 c-danger"> {{ tituloMensagemErro }} </p>
      <div class="footer-alert bg-danger">
        <p class="subtitulo-alert mt-3"> {{ mensagemErro }} </p>
        @if (mensagemErro == 'Ocorreu um erro durante a importação, por favor verifique os erros e suba o arquivo novamente.' || mensagemErro == 'Erro referente ao layout do arquivo, por favor arrume o arquivo e importe-o de novo.') {
          <button class="botao-erro me-3 mt-3" routerLink="/visualizar-erros-importacao"
          [tag]="addTagManagerInteraction('box:button:click', 'ver-erros')">Ver erros</button>
        }
        @if (!botao2) {
          <button class="botao-cancelar-outline mt-3" (click)="cancelarImportacao()"
          [tag]="addTagManagerInteraction('box:button:click', 'fechar')">FECHAR</button>
        }
        @if (botao2) {
          <button class="botao-erro mt-3" (click)="cancelarImportacao()"
          [tag]="addTagManagerInteraction('box:button:click', 'sair')">SAIR</button>
        }
      </div>
    </div>
  </div>
}


